import "./siteFooter.css";

export default function SiteFooter({
  title = "Blåhaj",
  text = "Free AI mock interview practice.",
  variant = "full", // "full" | "minimal"
}) {
  const showBrand = variant === "full";

  return (
    <footer className="siteFooter" aria-label="Footer">
      <div className="siteFooter__inner">
        {showBrand ? <div className="siteFooter__title">{title}</div> : null}
        {showBrand ? <div className="siteFooter__text">{text}</div> : null}
        <div className="siteFooter__legal">
          (c) 2026{" "}
          <a href="https://github.com/ace-n" target="_blank" rel="noreferrer">
            Ace Nassri
          </a>{" "}
          | Built with{" "}
          <a href="https://fontawesome.com/" target="_blank" rel="noreferrer">
            FontAwesome
          </a>
        </div>
      </div>
    </footer>
  );
}


